import {
  DefaultDesktopLeftLat,
  DefaultDesktopLeftLng,
  DefaultDesktopUpperLat,
  DefaultDesktopUpperLng,
  DefaultMobileLeftLat,
  DefaultMobileLeftLng,
  DefaultMobileRightLat,
  DefaultMobileRightLng
} from '../../../../../../../core/src'
import { IMapBounds } from '../interfaces/i-map-bounds'

export class MapBoundsGetters {
  static hasBounds(query: Record<string, any>): boolean {
    const { lowerLeftLng, upperRightLng, lowerLeftLat, upperRightLat } = query
    return lowerLeftLng && upperRightLng && lowerLeftLat && upperRightLat
  }

  static getBounds(query: Record<string, any>, isMobile: boolean): IMapBounds {
    const defaultBounds = {
      lowerLeftLng: isMobile ? DefaultMobileLeftLng : DefaultDesktopLeftLng,
      lowerLeftLat: isMobile ? DefaultMobileLeftLat : DefaultDesktopLeftLat,
      upperRightLng: isMobile ? DefaultMobileRightLng : DefaultDesktopUpperLng,
      upperRightLat: isMobile ? DefaultMobileRightLat : DefaultDesktopUpperLat,
    }

    return {
      lowerLeftLng: query.lowerLeftLng || defaultBounds.lowerLeftLng,
      lowerLeftLat: query.lowerLeftLat || defaultBounds.lowerLeftLat,
      upperRightLng: query.upperRightLng || defaultBounds.upperRightLng,
      upperRightLat: query.upperRightLat || defaultBounds.upperRightLat,
    }
  }
}
